<template>
  <div
    class="w-full flex bg-white my-2 justify-center px-6 py-10 height-100 rounded-10px"
  >
    <div class="flex justify-center w-28per items-center">
      <div class="elshadow px-6 w-full py-10 rounded-2xl">
        <div class="text-center">
          <h1 class="fsize22 text-dark font-semibold">Forgot password</h1>
          <p class="fsize14 text-gray justify-center pt-2 flex">
            Check your inbox to access this credentials
          </p>
        </div>
        <div class="mt-6">
          <div class="mt-4">
            <div class="relative mt-4">
              <small class="fsize12 bg-white text-dark font-medium"
                >New Password</small
              >
              <el-input
                placeholder="New Password"
                v-model="password"
                class="rounded-xl mt-2"
                show-password
              />
            </div>

            <div class="relative mt-4">
              <small class="fsize12 bg-white text-dark font-medium"
                >Confirm Password</small
              >
              <el-input
                placeholder="Confirm Password"
                class="rounded-xl mt-2"
                v-model="confirmPass"
                type="password"
              />
            </div>
            <p v-if="passwordMatch == true" class="text-success fsize10">
              New Password and Confirm Password Match
            </p>
            <p v-else-if="passwordMatch == false" class="text-danger fsize10">
              New Password and Confirm Password does not match
            </p>
            <div class="flex flex-wrap gap-2 mt-2">
              <h2
                class="m-1 cust-chips flex items-center gap-1"
                :class="{ 'chips-active': uperCaseCharacter() }"
              >
                <feather-icon
                  icon="CheckIcon"
                  svgClasses="w-4 h-4"
                  class="font-semibold"
                  :hidden="uperCaseCharacter() == false"
                />
                {{ `1 uppercase` }}
              </h2>
              <h2
                class="m-1 cust-chips flex items-center gap-1"
                :class="{ 'chips-active': specialCharacter() }"
              >
                <feather-icon
                  icon="CheckIcon"
                  svgClasses="w-4 h-4"
                  class="font-semibold"
                  :hidden="specialCharacter() == false"
                />
                {{ `1 special character` }}
              </h2>
              <h2
                class="m-1 cust-chips flex items-center gap-1"
                :class="{ 'chips-active': pwdLength() }"
              >
                <feather-icon
                  icon="CheckIcon"
                  svgClasses="w-4 h-4"
                  class="font-semibold"
                  :hidden="pwdLength() == false"
                />
                {{ `character length more than 8` }}
              </h2>
              <h2
                class="m-1 cust-chips flex items-center gap-1"
                :class="{ 'chips-active': numericCharacter() }"
              >
                <feather-icon
                  icon="CheckIcon"
                  svgClasses="w-4 h-4"
                  class="font-semibold"
                  :hidden="numericCharacter() == false"
                />
                {{ `1 numeric character` }}
              </h2>
            </div>
          </div>

          <div class="mt-4">
            <vs-button
              @click="createPassword"
              variant="primary"
              class="rounded-full bg-primary border-0 text-white font-normal lg:py-3 fsize14 md:py-3 py-2 w-full sm-fsize14"
            >
              Proceed
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      password: "",
      confirmPass: "",
      passwordMatch: null,
    };
  },
  props: {
    Email: String,
  },

  methods: {
    async createPassword() {
      if (this.password !== null && this.password == this.confirmPass) {
        const payload = {
          email: this.Email,
          password: this.password,
        };
        const data = await this.$store.dispatch(
          "admin/createNewPassword",
          payload
        );
        if (data.code == 200) {
          this.email = "";
        }
        console.log("helllo");
        this.$router.push({ name: "login" });
        console.log("by");
      } else {
        this.$swal("your password doesnt match");
      }
    },
    uperCaseCharacter() {
      return this.password.length && this.password.match(/[A-Z]/g) === null
        ? false
        : this.password.length && this.password.match(/[A-Z]/g).length
        ? true
        : false;
    },

    numericCharacter() {
      return this.password.length && this.password.match(/[0-9]/g) === null
        ? false
        : this.password.length && this.password.match(/[0-9]/g).length
        ? true
        : false;
    },

    specialCharacter() {
      return this.password.length &&
        this.password.match(/[!,@,#,$,%,^,&,*]/g) === null
        ? false
        : this.password.length &&
          this.password.match(/[!,@,#,$,%,^,&,*]/g).length
        ? true
        : false;
    },

    pwdLength() {
      return this.password.length > 7 ? true : false;
    },
  },
  watch: {
    password(newvalue) {
      if (newvalue.length != 0) {
        if (newvalue == this.confirmPass) {
          this.passwordMatch = true;
        } else {
          this.passwordMatch = false;
        }
      } else {
        this.passwordMatch = null;
      }
    },

    confirmPass(newvalue) {
      if (newvalue.length != 0) {
        if (newvalue == this.password) {
          this.passwordMatch = true;
        } else {
          this.passwordMatch = false;
        }
      } else {
        this.passwordMatch = null;
      }
    },
  },
};
</script>

<style>
.col-ffc1 {
  color: #ffc148 !important;
}
.col-56 {
  color: #f6f6f6 !important;
}
.col-4f {
  color: #4f4f4f !important;
}
.bg-f9 {
  background: #f9f9f9 !important;
}
.third-fonts {
  line-height: 19px;
  font-size: 17px !important;
  color: #000 !important;
}
.second-fonts {
  line-height: 19px;
  font-size: 17px !important;
}
.bordb {
  border-bottom: 1px solid #ececec;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: rgb(205, 49, 151) !important;
  color: #fff !important;
  border-radius: 4px !important;
  border: none !important;
}
.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none !important;
}
.bg-light-green {
  background: rgba(111, 205, 87, 0.16) !important;
  color: #6fcd57 !important;
}
.greenh {
  background: #6fcd57 !important;
  width: 3px !important;
  height: 3px !important;
  border-radius: 50% !important;
}
.bg-light-orange {
  background: rgba(255, 143, 11, 0.13) !important;
  color: #ff8f0b !important;
}
.cust-chips {
  font-size: 10px;
  color: grey;
  font-weight: 500;
  background: #f4f5f6;
  padding: 6px 10px;
  border-radius: 18px;
}
.chips-active {
  background-color: rgba(40, 199, 111, 0.12) !important;
  color: #2dce89 !important;
  font-weight: 600;
}
.w-28per {
  width: 28%;
}
</style>
